import { defineComponent as _defineComponent } from 'vue'
import AppPage from "@/components/layout/AppPage.vue"
import Tab from "@/components/widgets/Tabs/Tab.vue"
import Tabs from "@/components/widgets/Tabs/Tabs.vue"
import OpportunitiesTab from "@/modules/Consultant/Opportunities/OpportunitiesTab.vue"
import ApplicationsTab from "@/modules/Consultant/Opportunities/ApplicationsTab.vue"
import { useTranslation } from "@/i18n/useTranslation"


export default /*#__PURE__*/_defineComponent({
  __name: 'Opportunities',
  setup(__props) {

const { t } = useTranslation("Consultant/Opportunities")

const tabs = [
  {
    label: t("tabOpportunities"),
    key: "opportunities",
  },
  {
    label: t("tabApplications"),
    key: "applications",
  },
]

return { __sfc: true,t, tabs, AppPage, Tab, Tabs, OpportunitiesTab, ApplicationsTab }
}

})